import React from 'react';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import {connect} from 'react-redux'
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Typography from "@mui/material/Typography";
import {useTranslation} from 'react-i18next';
import { useHistory } from '../../../utils/reactRouterCompatibility';
import Button from "../../inputs/Button";
import {deleteAlbum} from "../../../../store/actions/discography/AlbumAction";
import {getMusicAlbumsRoute} from "../../../../router/routes/music/factory/album";

const DeleteDialog = ({open, setOpen, deleting, album, deleteAlbum}) => {
    const {t} = useTranslation();
    const history = useHistory();

    const handleClose = () => {
        setOpen(false);
    };

    const handleDelete = () => {
        deleteAlbum(album.Music_Label_Album__)
            .then(() => {
                handleClose();
                history.push(getMusicAlbumsRoute())
            })
    };

    return (
        <Dialog
            open={open}
            aria-labelledby={t('delete_album')}
            aria-describedby={t('delete_album')}
            fullWidth
        >
            <DialogTitle id="album-delete-title">{t('confirm_delete_album_title')}</DialogTitle>
            <DialogContent>
                <DialogContentText id="album-delete-description">
                    {t('confirm_delete_album_desc')}
                    <br/>
                    <Typography variant="body1" color="textPrimary" component="span">{t('are_you_sure')}</Typography>
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button variant='contained' color="primary" autoFocus onClick={handleClose} disabled={deleting}>
                    {t('back_btn')}
                </Button>
                <Button color="secondary" disabled={deleting} loading={deleting} endIcon={<DeleteForeverIcon/>}
                        onClick={handleDelete}>
                    {t('delete_btn')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const mapStateToProps = (state) => {
    return {
        deleting: state.album.deleting
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        deleteAlbum: (albumId) => dispatch(deleteAlbum(albumId))
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(DeleteDialog);